import { bootstrapApplication, createApplication } from '@angular/platform-browser';
import { AppComponent } from 'app/app.component';
import { createCustomElement } from '@angular/elements';
import { appConfig } from 'app/app.config';
import { LayoutWebComponent } from 'app/layout/layouts/layout-web/layout-web.component';
import { appConfigweb } from 'app/web.config';

if (window.location.host == 'localhost' || window.location.host == 'localhost:4201'|| window.location.host == 'localhost:8080'|| window.location.host =='dev-api.paradigmdrive.com' || window.location.host =='paradigmdrive.com' || window.location.host =='drive.lycusinc.com') {
  bootstrapApplication(AppComponent, appConfig)
    .catch(err => console.error(err));
    
} else {
  async function webComponentApp() {
    try {
        console.log("Starting web component initialization...");
  
        const app = await createApplication(appConfigweb);
        // console.log("Application created successfully.");
  
        const element = createCustomElement(LayoutWebComponent, {
            injector: app.injector,
        });
  
        // console.log("Web component created:", element);
  
        if (!customElements.get('dms-app')) {
            customElements.define('dms-app', element);
            console.log("Web component <dms-app> registered successfully.");
        } else {
            console.warn("Web component <dms-app> is already defined.");
        }
  
    } catch (error) {
        console.error("Error initializing web component:", error);
    }
  }

  (async function () {
    await webComponentApp();
  })();
}
